import React from "react";
import "./styles/PricingTier.css";

interface PricingFeature {
  label: string;
  included: boolean;
}

interface PricingTierProps {
  title: string;
  price: string;
  oldPrice?: string;
  features: PricingFeature[];
  highlight?: boolean;
  tag?: string;
  buttonText: string;
  onClick?: () => void;
}

const PricingTier: React.FC<PricingTierProps> = ({
  title,
  price,
  oldPrice,
  features,
  highlight = false,
  tag,
  buttonText,
  onClick,
}) => {
  return (
    <div className={`pricing-tier ${highlight ? "highlighted" : ""}`}>
      {tag && <div className="tier-tag">{tag}</div>}
      <h3 className="tier-title">{title}</h3>
      <div className="tier-price">
        {oldPrice && <span className="old-price">${oldPrice}</span>}
        <span className="new-price">${price}/m</span>
      </div>
      <ul className="tier-features">
        {features.map((feature, i) => (
          <li key={i} className={feature.included ? "included" : "excluded"}>
            {feature.included ? "✅" : "❌"} {feature.label}
          </li>
        ))}
      </ul>
      <button className="tier-button" onClick={onClick}>
        {buttonText}
      </button>
    </div>
  );
};

export default PricingTier;
